

export default function setUploadReadyAction(uploadReady) {
    return {
        type: 'SET_UPLOAD_READY',
        payload: uploadReady
    }
}